<script>
import {
  paymentMethodCarteMalinEurocoraEmits,
  paymentMethodCarteMalinEurocoraProps,
  usePaymentMethodCarteMalinEurocora
} from "./mixin";

import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import FormInput from "@/components/molecules/form-input";
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Form from "@/components/molecules/form";
import FormGroup from "@/components/molecules/form-group";
import Titre from "@/components/atoms/titre";

export default {
  name: "PaymentMethodEurocora",
  components: {
    Form,
    FormGroup,
    FormInput,
    Button,
    ButtonIcon,
    Icon,
    Popin,
    Titre
  },
  props: { ...paymentMethodCarteMalinEurocoraProps() },
  emits: [...paymentMethodCarteMalinEurocoraEmits()],
  setup(props, context) {
    const {
      v$,
      getState,
      getErrorMessage,
      states,
      internalMontantAdeduire,
      keyUtiliserTouteLaCagnotte,
      success,
      montantAsString,
      typeCarteLabel,
      utiliserTouteLaCagnotte,
      handleBlur,
      validate,
      cancel
    } = usePaymentMethodCarteMalinEurocora(props, context);
    return {
      v$,
      getState,
      getErrorMessage,
      states,
      internalMontantAdeduire,
      keyUtiliserTouteLaCagnotte,
      success,
      montantAsString,
      typeCarteLabel,
      utiliserTouteLaCagnotte,
      handleBlur,
      validate,
      cancel
    };
  }
};
</script>

<template>
  <div>
    <div class="c-payment-method-eurocora">
      <p>
        <span class="u-font-secondary u-font-18 u-font-700">
          J’utilise mes €urocora carte</span>
        <span class="u-word-nowrap">
          <span class="u-font-secondary u-font-18 u-font-700">
            {{ typeCarteLabel }}
          </span>
          <ButtonIcon
            size="xs"
            radius="full"
            variant="white"
            icon-name="info-circle-outline"
            icon-color="primary"
            icon-color-hover="primary-light"
            icon-position="left"
            icon-size="sm"
            circle
            class="c-payment-method-eurocora__info u-flex-shrink-none u-ml-xs"
            @click="$refs.infoEurocora.show()"
          />
        </span>
      </p>
      <div v-if="success">
        <div class="c-payment-method-eurocora__success-text">
          <p class="u-font-16">
            {{ internalMontantAdeduire }}€ seront bien déduits<br>
            lors du retrait de votre commande
          </p>
          <Icon
            name="check"
            variant="success"
            size="md"
            class="u-flex-shrink-none"
          />
        </div>
        <div class="u-mt-xs">
          <Button
            link
            @click="cancel()"
          >
            Annuler
          </Button>
        </div>
      </div>
      <Form
        v-else
        class="c-payment-method-eurocora__form"
        @submit.prevent="validate()"
      >
        <div>
          <div class="u-flex u-flex-row u-flex-align-center u-mb-xxs">
            <FormGroup
              size="full"
              class="c-payment-method-eurocora__input"
            >
              <FormInput
                :key="`montant-deduire-${keyUtiliserTouteLaCagnotte}`"
                v-model.trim="internalMontantAdeduire"
                :placeholder="false"
                size="sm"
                suffix="€"
                autocomplete="off"
                autocapitalize="off"
                :state="getState(v$,'internalMontantAdeduire')"
                @blur="handleBlur()"
                @input="val => $emit('input', val)"
              />
            </FormGroup>
            <span class="u-font-15 u-ml-xs">sur {{ formatPrix(montant) }}€</span>
          </div>
          <Button
            link
            align="left"
            @click="utiliserTouteLaCagnotte()"
          >
            Utiliser toute ma cagnotte
          </Button>
        </div>
        <Button
          size="sm"
          outline
          radius="full"
          variant="primary"
          type="submit"
          value="Utiliser ce montant"
          :disabled="internalMontantAdeduire === ''"
        />
        <template #message>
          <p
            v-if="getState(v$,'internalMontantAdeduire') === states.ERROR"
            class="u-color-alert u-text-center u-font-15 u-mt-sm"
          >
            {{ getErrorMessage("internalMontantAdeduire",`Merci de renseigner un montant entre 0 et ${montantAsString} €`) }}
          </p>
        </template>
      </Form>
    </div>
    <Popin
      ref="infoEurocora"
      aria-label="Utiliser ses €urocora"
      slide-up
    >
      <div class="u-pb-lg">
        <div class="u-text-center">
          <Icon
            name="tirelire"
            variant="primary"
            class="u-mb-xxs"
            size="xxlg"
          />
          <Titre
            tag="h2"
            variant="primary"
            class="u-mb-sm"
          >
            Utiliser ses €urocora
          </Titre>
        </div>
        <p class="u-font-16 u-mb-xs">
          Vous avez la possibilité de déduire la totalité ou une partie de vos €urocora
        </p>
        <p class="u-font-16">
          Vos €urocora seront déduits lors du retrait. Sous réserve que votre cagnotte soit identique et toujours disponible au moment du retrait.<br>
          Si vous choisissez le paiement en plusieurs fois, la déduction de vos €urocora ne sera pas possible.
        </p>
      </div>
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/payment-method-eurocora.scss";
</style>
